// extracted by mini-css-extract-plugin
export default {"body":"SpecsComponent_body__PHm53","string":"SpecsComponent_string__RegbW","group":"SpecsComponent_group__29Okz"};